import React, { useCallback } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Typography from '@material-ui/core/Typography'
import Checkbox from 'ui/components/checkbox'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from 'ui/components/tooltip'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconVerified } from 'assets/icons/verified.svg'
import { ReactComponent as IconDenied } from 'assets/icons/denied.svg'
import { ReactComponent as IconDelete } from 'assets/icons/delete.svg'
import { ReactComponent as IconResend } from 'assets/icons/email.svg'
import useStyles from './stylesItem'
import useTranslation from 'hooks/useTranslations'

const Item = props => {
  const {
    id,
    vendorId,
    title,
    onSelect,
    isHomologated,
    showHomologated,
    isPending,
    isSelected,
    onRemoveVendor,
    canDelete,
    showResend,
    email,
    onResendInvitation,
  } = props

  const t = useTranslation()

  const classes = useStyles()

  const itemSelect = e => {
    e.stopPropagation()
    e.preventDefault()
    onSelect(id)
  }

  const handleRemoveVendor = useCallback(() => {
    onRemoveVendor(id)
  }, [id, onRemoveVendor])

  const handleResendInvitation = useCallback(() => {
    onResendInvitation(id, email)
  }, [id, email, onResendInvitation])

  return (
    <ListItem
      className={clsx(classes.root, isSelected && classes.isChecked)}
      button
      component={isPending ? null : Link}
      to={
        isPending
          ? null
          : {
              pathname: `/app/vendors/${vendorId || id}`,
              state: { from: 'vendors' },
            }
      }
      divider
      role="listitem"
      ContainerProps={{ className: classes.item }}
    >
      {canDelete ? (
        <ListItemIcon className={classes.itemCheckboxWrapper}>
          <Checkbox
            className={classes.itemCheckbox}
            edge="start"
            color="primary"
            onClick={itemSelect}
            checked={isSelected}
            tabIndex={-1}
            disableRipple
          />
        </ListItemIcon>
      ) : null}
      {isPending ? (
        <Tooltip
          title={t('tooltip:registration-pending')}
          arrow
          placement="top-start"
        >
          <ListItemText
            className={clsx(classes.itemText, isPending && classes.isPending)}
            disableTypography
            primary={
              <Typography variant="body2" noWrap>
                {title}
              </Typography>
            }
          />
        </Tooltip>
      ) : (
        <ListItemText
          className={clsx(classes.itemText, isPending && classes.isPending)}
          disableTypography
          primary={
            <Typography className={classes.primary} variant="body2" noWrap>
              {title}
            </Typography>
          }
        />
      )}
      <ListItemSecondaryAction className={classes.itemActions}>
        {showHomologated ? (
          isHomologated ? (
            <Tooltip title={t('tooltip:homologate')} arrow placement="top">
              <IconButton
                className={clsx(classes.itemButton, classes.iconGold)}
                edge="end"
                aria-label="comments"
              >
                <SvgIcon
                  className={classes.itemIcon}
                  component={IconVerified}
                />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title={t('tooltip:no-homologate')} arrow placement="top">
              <IconButton
                className={clsx(classes.itemButton, classes.iconGrey)}
                edge="end"
                aria-label="comments"
              >
                <SvgIcon className={classes.itemIcon} component={IconDenied} />
              </IconButton>
            </Tooltip>
          )
        ) : null}

        {showResend ? (
          <Tooltip title={t('tooltip:resend-invitation')} arrow placement="top">
            <IconButton
              className={classes.deleteButton}
              edge="end"
              aria-label="comments"
              onClick={handleResendInvitation}
            >
              <SvgIcon className={classes.itemIconBig} component={IconResend} />
            </IconButton>
          </Tooltip>
        ) : null}

        {canDelete ? (
          <Tooltip title={t('tooltip:delete-provider')} arrow placement="top">
            <IconButton
              className={classes.deleteButton}
              edge="end"
              aria-label="comments"
              onClick={handleRemoveVendor}
            >
              <SvgIcon className={classes.itemIconBig} component={IconDelete} />
            </IconButton>
          </Tooltip>
        ) : null}
      </ListItemSecondaryAction>
    </ListItem>
  )
}

Item.propTypes = {
  id: PropTypes.string,
  email: PropTypes.string,
  vendorId: PropTypes.string,
  title: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  showHomologated: PropTypes.bool,
  isHomologated: PropTypes.bool,
  isPending: PropTypes.bool,
  isSelected: PropTypes.bool,
  onRemoveVendor: PropTypes.func,
  onResendInvitation: PropTypes.func,
}

export default Item
